var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsMissing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32_359)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 12H17V55H60V12ZM35.0796 39.9745V40.1577H38.7443V39.9745C38.7647 38.7121 38.897 37.6585 39.1413 36.8136C39.3857 35.9686 39.7776 35.2408 40.3171 34.63C40.8567 34.009 41.5743 33.4186 42.4702 32.8587C43.366 32.309 44.1295 31.6778 44.7607 30.9652C45.402 30.2526 45.8906 29.4433 46.2266 28.5373C46.5726 27.6313 46.7457 26.6184 46.7457 25.4986C46.7457 23.9105 46.3793 22.4955 45.6463 21.2535C44.9235 20.0116 43.8954 19.0343 42.5618 18.3217C41.2384 17.6091 39.6809 17.2528 37.8892 17.2528C36.2401 17.2528 34.7385 17.5786 33.3846 18.2301C32.0409 18.8816 30.9567 19.8232 30.1321 21.0551C29.3177 22.2868 28.8698 23.768 28.7884 25.4986H32.6363C32.7178 24.2973 33.0181 23.3252 33.5373 22.582C34.0565 21.8389 34.7029 21.2942 35.4766 20.9482C36.2502 20.602 37.0545 20.429 37.8892 20.429C38.8462 20.429 39.7165 20.6275 40.5004 21.0245C41.2842 21.4215 41.9102 21.9865 42.3785 22.7194C42.8468 23.4524 43.081 24.3177 43.081 25.3154C43.081 26.1196 42.9384 26.8525 42.6534 27.5142C42.3785 28.1759 42.0019 28.7613 41.5234 29.2702C41.045 29.7691 40.5054 30.2017 39.9048 30.5682C38.9072 31.1688 38.0521 31.8254 37.3395 32.538C36.6269 33.2506 36.0772 34.1821 35.6904 35.3324C35.3035 36.4827 35.0999 38.03 35.0796 39.9745ZM35.0948 48.3881C35.6343 48.9277 36.2808 49.1974 37.0341 49.1974C37.5431 49.1974 38.0012 49.0753 38.4084 48.831C38.8257 48.5765 39.1566 48.2405 39.4009 47.8232C39.6554 47.4058 39.7827 46.9477 39.7827 46.4488C39.7827 45.6955 39.5129 45.0491 38.9733 44.5096C38.4338 43.97 37.7874 43.7003 37.0341 43.7003C36.2808 43.7003 35.6343 43.97 35.0948 44.5096C34.5553 45.0491 34.2855 45.6955 34.2855 46.4488C34.2855 47.2022 34.5553 47.8486 35.0948 48.3881Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32_359",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32_359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32_359",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsMissing);
export default __webpack_public_path__ + "static/media/whats-missing.84a6d5edf5d358e699a0e0bc2e8399e7.svg";
export { ForwardRef as ReactComponent };